import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider
} from '@material-ui/core';
import { Component } from 'react';
import {
  getDeletionConfirmationMessage,
  classifyFlagsForDeletionAndSharing
} from '../../../utils/flag';

export default class ConfirmationDeleteModal extends Component {
  renderDialogText = () => {
    const {
      flagIdsToBeDeleted,
      restrictedFlags
    } = classifyFlagsForDeletionAndSharing(this.props.flags);

    const dialogMessage = getDeletionConfirmationMessage(
      flagIdsToBeDeleted,
      restrictedFlags
    );

    return (
      <>
        <span>{dialogMessage}</span>
      </>
    );
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="delete-dialog"
      >
        <div className="delete-dialog__container">
          <DialogTitle id="alert-dialog-title" className="delete-dialog__title">
            {this.props.flags.length === 1 ? 'Delete Flag' : 'Delete Flags'}
          </DialogTitle>
          <Divider
            className="dialog-title-divider"
            variant="fullWidth"
            style={{ marginBottom: '6px' }}
          />
          <DialogContent className="delete-dialog__content-container">
            <div className="delete-dialog__content">
              <DialogContentText
                id="alert-dialog-description"
                className="delete-dialog__text"
              >
                {this.renderDialogText()}
              </DialogContentText>
            </div>
          </DialogContent>
          <DialogActions className="delete-dialog__actions">
            <Button
              className="cancel-dialog dialog-btn"
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
            <Button
              className="confirm-dialog dialog-btn"
              onClick={this.props.onConfirm}
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    );
  }
}
